import { render } from "./AbortTeaser.vue?vue&type=template&id=a6c9ff52&scoped=true"
import script from "./AbortTeaser.vue?vue&type=script&lang=js"
export * from "./AbortTeaser.vue?vue&type=script&lang=js"

import _style_0 from "./AbortTeaser.vue?vue&type=style&index=0&id=a6c9ff52&inline&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-a6c9ff52"]])

export default __exports__